import { Injectable } from "@angular/core";
import { Course } from "../Models/course.model";
import { Observable } from "rxjs/Observable";
import {map} from 'rxjs/operators';
import { ApiService } from "./api.service";
import { ContactModel } from "../Models/contact.model";
import { CourseRegistrationModel, RegistrationModel } from "../Models/registration.model";

@Injectable()
export class ContactService{

    constructor(
        private _apiService: ApiService,
    ){}

    saveContactRequest(request: ContactModel): Observable<ContactModel>{
        return this._apiService.post(`/contact/sendContactRequest`, request)
            .pipe(map((data) => data.response)); 
    }

    saveRegistrationRequest(request: CourseRegistrationModel[]): Observable<number[]>{
        return this._apiService.post(`/contact/saveRegistrationRequest`, request)
            .pipe(map((data) => data.response)); 
    }
}


// WEBPACK FOOTER //
// ./src/app/Services/contact.service.ts